import { Link } from "react-router-dom";
import { t } from "ttag";

import { POST_MEETING_STATUS } from "@/features/consultations/models";
import type { Appointment } from "@/features/consultations/models";
import { formatDate, formatTime } from "@/shared/lib";
import { Badge, EmptyState, LinkMinimalistic, TableCard } from "@/shared/ui";
import { formatFullName } from "@/shared/utils";

interface PastAppointmentsCardsProps {
  sessions: Appointment[];
}

export const PastAppointmentsCards = ({
  sessions,
}: PastAppointmentsCardsProps) => {
  if (!sessions.length) {
    return (
      <EmptyState.Root className="md:hidden">
        <EmptyState.Icon />
        <EmptyState.Description>
          {t`You haven't had any appointment yet`}
        </EmptyState.Description>
      </EmptyState.Root>
    );
  }

  return (
    <TableCard.Root>
      {sessions.map(
        ({ id, provider, startTime, endTime, pmStatus, videoUrl }) => (
          <TableCard.Row key={id}>
            <TableCard.Cell>
              <TableCard.Label>{t`Type`}</TableCard.Label>
              <TableCard.Data>{t`Journey support`}</TableCard.Data>
            </TableCard.Cell>

            <TableCard.Cell>
              <TableCard.Label>{t`Coach`}</TableCard.Label>
              <TableCard.Data>
                {provider?.fullName ? formatFullName(provider.fullName) : "-"}
              </TableCard.Data>
            </TableCard.Cell>

            <TableCard.Cell>
              <TableCard.Label>{t`Date`}</TableCard.Label>
              <TableCard.Data>{formatDate(startTime)}</TableCard.Data>
            </TableCard.Cell>

            <TableCard.Cell>
              <TableCard.Label>{t`Time`}</TableCard.Label>
              <TableCard.Data>
                {`${formatTime(startTime)} - ${formatTime(endTime)}`}
              </TableCard.Data>
            </TableCard.Cell>

            <TableCard.Cell>
              <Badge
                color={
                  pmStatus !== POST_MEETING_STATUS.CANCELLED
                    ? "light-secondary"
                    : "red"
                }
                className="min-w-24"
              >
                {pmStatus}
              </Badge>

              {videoUrl ? (
                <Link
                  to={videoUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-0.5 text-neutral-950"
                >
                  <LinkMinimalistic className="size-4" />
                  {t`Note`}
                </Link>
              ) : (
                <TableCard.Data>-</TableCard.Data>
              )}
            </TableCard.Cell>
          </TableCard.Row>
        ),
      )}
    </TableCard.Root>
  );
};
